module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Bright_diameter.36cc9a8e.png";